import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { PropertyLevelOffersCard } from '@shared-ui/lodging-property-offers';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const PropertyLevelOffersCardWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <ErrorBoundary label="PropertyLevelOffersCard">
    <UitkSpacing margin={{ small: { inline: 'three' }, medium: { inline: 'unset' } }}>
      <div>
        <PropertyLevelOffersCard inputs={inputs} showBorder={false} skipSsr />
      </div>
    </UitkSpacing>
  </ErrorBoundary>
);

PropertyLevelOffersCardWrapper.displayName = 'PropertyLevelOffersCardWrapper';
export const SharedUiPropertyLevelOffersCardWrapper = withSharedUiPropertyOffers(PropertyLevelOffersCardWrapper);
